import { v2 } from '@/api/client';

export const updatePreferredDeliveryPoint = (deliveryPointEntityId: string) =>
  v2.put<void>(
    'user/me/deliverypoint',
    { deliveryPointEntityId },
    { responseType: 'void' }
  );
